export const fallbackPartner = "asurion";
export const fallbackLob = "soluto";
